<template>
  <div ref="subGlobal" class="global-main global-shadow">

    <!-- ---------------------- 索引表格 ---------------------- -->
    <div class='global-panel' v-loading.body="loading.main">
      <div class="global-header">
        <div class="global-title">学生管理</div>
        <div class='global-tbar'>
          <el-upload class="upload-demo"
                     :action="'rest/student/uploadStudentFile' "
                     :on-progress="uploadProgress"
                     :on-error="uploadError" :on-success="uploadSuccess" :on-preview="handlePreview"
                     :on-remove="handleRemove" :file-list="fileList" :show-file-list='false'
                     list-type="picture">
            <el-button type="primary" size="small" icon="el-icon-upload2">上传excel</el-button>
          </el-upload>
          <el-button size="small" type="success"  @click="downloadAttachment()">下载模板</el-button>
          <el-button size="small" type="warning"  @click="openCompare()">学生比对</el-button>
          <el-button size="small" type="danger"  @click="addStudent()">新增</el-button>
          <el-input size="small" v-model="condition.studentName" placeholder="姓名"></el-input>
          <el-input size="small" v-model="condition.seriaNo" placeholder="学号"></el-input>
          <el-input size="small" v-model="condition.clazzName" placeholder="班级"></el-input>
          <el-button size="small" type="primary"  @click="findByCondition()">检索</el-button>
        </div>
      </div>
      <hr>
      <div class='global-body'>
        <div class="global-paging" v-show="paging.allNum > paging.everySize" >
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
        <el-table :data="studentList" border stripe style="width: 100%" size="mini" highlight-current-row >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="seriaNo" label="学工号" width="200"></el-table-column>
          <el-table-column prop="studentName" label="姓名" width="150" sortable></el-table-column>
          <el-table-column prop="telephone" label="手机号" width="200" sortable show-overflow-tooltip></el-table-column>
          <el-table-column prop="clazzName" label="班级" width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="note" label="备注" min-width="100" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button class="global-text-btn-success" size="mini" type="text" @click="showStudent(scope.row)" style="margin-left: 10px;">编辑</el-button>
              <el-button class="global-text-btn-danger" size="mini" type="text" @click="dropStudent(scope.row)" style="margin-left: 10px;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页  -->
        <div v-show="paging.allNum > paging.everySize" class="global-paging">
          <hr/>
          <el-pagination layout="prev, pager, next" @current-change="findByCondition(arguments[0])" :current-page="paging.currPage" :page-size="paging.everySize" :total="paging.allNum"></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="visible.param" width="50%" v-loading="loading.param" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="serverForm"  :model="currentRecord" label-width="80px":rules="serverRules">
        <el-form-item label="学工号" prop="seriaNo">
          <el-input v-model="currentRecord.seriaNo"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="studentName">
          <el-input v-model="currentRecord.studentName"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="currentRecord.password" type="password"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input v-model="currentRecord.telephone"></el-input>
        </el-form-item>
        <el-form-item label="班级" prop="clazzName">
          <el-input v-model="currentRecord.clazzName"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input v-model="currentRecord.note"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.param = false">取 消</el-button>
      <el-button type="primary" @click="saveStudent()">保 存</el-button>
    </span>
    </el-dialog>
    <!-- ---------------------- 学生比对弹窗 ---------------------- -->
    <el-dialog :visible.sync="visible.compare" width="60%" v-loading="loading.compare" :close-on-click-modal="false" :close-on-press-escape="false" title="学生比对">
      <el-row>
        <el-input v-model="compareGrade" placeholder="请输入年级（Grade）" size="small" style="width:180px"></el-input>
        <el-input v-model="compareSchoolArea" placeholder="请输入校区（可不填）" size="small" style="width:180px;margin-left:10px"></el-input>
        <el-upload style="display:inline-block;margin-left:10px"
                   :action="'rest/student/compareStudent'"
                   :data="{grade: compareGrade, schoolArea: compareSchoolArea || ''}"
                   :before-upload="beforeCompareUpload"
                   :on-error="uploadError" :on-success="compareSuccess"
                   :show-file-list='false'>
          <el-button type="primary" size="small" icon="el-icon-upload2">上传excel开始比对</el-button>
        </el-upload>
      </el-row>
      <el-row v-if="compareResult.excelOnly.length > 0" style="margin-top:15px">
        <div style="color:red;font-weight:bold;padding-bottom:5px">Excel单独有（系统不存在，处理后插入系统并分配到对应班级）：</div>
        <el-table :data="compareResult.excelOnly" border stripe style="width: 100%" size="mini" max-height="250">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="seriaNo" label="学号" width="180"></el-table-column>
          <el-table-column prop="studentName" label="姓名" width="150"></el-table-column>
          <el-table-column prop="telephone" label="手机号" width="180"></el-table-column>
          <el-table-column prop="clazzName" label="班级" min-width="120"></el-table-column>
        </el-table>
      </el-row>
      <el-row v-if="compareResult.clazzMismatch.length > 0" style="margin-top:15px">
        <div style="color:red;font-weight:bold;padding-bottom:5px">班级不一致（两边都有该学生，处理后以Excel班级为准更新系统班级）：</div>
        <el-table :data="compareResult.clazzMismatch" border stripe style="width: 100%" size="mini" max-height="250">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="seriaNo" label="学号" width="180"></el-table-column>
          <el-table-column prop="studentName" label="姓名" width="150"></el-table-column>
          <el-table-column prop="clazzName" label="Excel班级" min-width="120"></el-table-column>
          <el-table-column prop="sysClazzName" label="系统班级" min-width="120"></el-table-column>
        </el-table>
      </el-row>
      <el-row v-if="compareResult.systemOnly.length > 0" style="margin-top:15px">
        <div style="color:red;font-weight:bold;padding-bottom:5px">系统单独有（Excel中没有，处理后移动到【休学】班级）：</div>
        <el-table :data="compareResult.systemOnly" border stripe style="width: 100%" size="mini" max-height="250">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="seriaNo" label="学号" width="180"></el-table-column>
          <el-table-column prop="studentName" label="姓名" width="150"></el-table-column>
          <el-table-column prop="clazzName" label="班级" min-width="120"></el-table-column>
        </el-table>
      </el-row>
      <span slot="footer" class="dialog-footer">
      <el-button @click="visible.compare = false">关 闭</el-button>
      <el-button type="primary" :disabled="compareResult.excelOnly.length === 0 && compareResult.clazzMismatch.length === 0 && compareResult.systemOnly.length === 0" @click="processCompare()">处 理</el-button>
    </span>
    </el-dialog>
  </div>

</template>

<script>

  export default {
    name: 'Student',
    data () {
      return {
        // 遮罩
        loading: {main: false, param: false, compare: false},
        // 可见
        visible: {param: false, compare: false},
        // 学生比对
        compareGrade: null,
        compareSchoolArea: null,
        compareResult: {excelOnly: [], clazzMismatch: [], systemOnly: []},
        // 检索条件
        condition: {studentName:null, seriaNo : null, clazzName : null},
        // 数据
        studentList: [],
        // 当前记录
        currentRecord: {},
        // 分页
        paging: {currPage: 1, everySize: 15, allNum: 0},
        // 校验规则
        serverRules: {
          seriaNo: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          studentName: [
            { required: true, message: '该项必填', trigger: 'change' }
          ],
          clazzName: [
            { required: true, message: '该项必填', trigger: 'change' }
          ]
        },
        fileList:[]
      }
    },

    /*
     * 初始化
     */
    mounted: function () {
      var vm = this;
      vm.$refs.subGlobal.style.minHeight = (window.innerHeight-vm.$baize.frameTitleHeight)+'px';

      vm.findByCondition();
    },

    methods: {
      /*
      * 查询所有
      */
      findByCondition: function (currentPage) {
        var vm = this;
        // 区分分页与查询
        if(currentPage){
          vm.paging.currPage = currentPage;
        } else {
          vm.paging.currPage = 1;
        }
        // 开启遮罩
        vm.loading.main = true;
        var params = vm.condition
        params.currPage = vm.paging.currPage
        params.everySize = vm.paging.everySize
        // 请求后台
        vm.$http.get('rest/student/findByCondition', {params: params}).then(response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 更新数据
          vm.studentList = response.body.studentList;
          vm.paging = response.body.pagingBean;
          // 提示
          vm.$notify({position: 'bottom-right', message: '检索完毕', type: 'success'});
        }, response => {
          // 关闭遮罩
          vm.loading.main = false;
          // 提示
          vm.$notify({position: 'bottom-right', type: 'error', message: '加载数据失败，请尝试刷新页面'});
          // 异常处理
          vm.$baize.handle(vm, response);
        })
      },
      addStudent: function () {
        var vm = this;
        vm.currentRecord = {id:null,seriaNo:null,studentName:null,password:null,telephone:null,note:null};
        vm.visible.param = true;
      },
      showStudent: function (record) {
        var vm = this;
        vm.currentRecord = JSON.parse(JSON.stringify(record));
        vm.visible.param = true;
      },
      dropStudent: function (record) {
        var vm = this;
        vm.$confirm('确定要【删除】学生[' + record.studentName + ']吗？', '提示', {type: 'error', closeOnClickModal: false}).then(() => {
          // 开启遮罩
          vm.loading.main = true;
          // 请求后台
          vm.$http.post('rest/student/dropStudent', null, {params: {id:record.id}}).then(function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '删除成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '删除失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        }).catch(() => {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'info', message: '取消删除'});
        });
      },
      saveStudent: function () {
        var vm = this;
        // 校验
        vm.$refs['serverForm'].validate((valid) => {
          if (!valid) {
            // 提示信息
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 获取焦点
            vm.$nextTick(() => {
              vm.$refs['serverForm'].$el.getElementsByClassName('is-error')[0].getElementsByTagName('input')[0].focus();
            })
            return false;
          }
          // 开启遮罩
          vm.loading.param = true;
          // 请求后台
          vm.$http.post('rest/student/saveStudent', vm.currentRecord).then(function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 关闭窗口
            vm.visible.param = false;
            // 刷新
            vm.findByCondition(vm.paging.currPage);
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '保存成功'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.param = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '保存失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        });
      },
      uploadProgress:function (event, file, fileList){
        var vm =this
        vm.loading.main = true;
      },
      uploadError:function (err, file, fileList){
        var vm =this
        vm.loading.main = false;
        // 弹出错误信息
        this.$alert(JSON.parse(err.message).message, '警告', {
          confirmButtonText: '确定',
          type: 'error'
        });
      },
      uploadSuccess:function (){
        var vm =this
        vm.loading.main = false;
        vm.$notify({position: 'bottom-right', type: 'success', message: '上传成功'});
        vm.findByCondition()
      },
      /*
      * 学生比对
      */
      openCompare: function () {
        var vm = this;
        vm.compareGrade = null;
        vm.compareSchoolArea = null;
        vm.compareResult = {excelOnly: [], clazzMismatch: [], systemOnly: []};
        vm.visible.compare = true;
      },
      beforeCompareUpload: function (file) {
        var vm = this;
        if (!vm.compareGrade) {
          vm.$notify({position: 'bottom-right', type: 'error', message: '请先输入年级'});
          return false;
        }
        vm.compareResult = {excelOnly: [], clazzMismatch: [], systemOnly: []};
        vm.loading.compare = true;
        return true;
      },
      compareSuccess: function (response) {
        var vm = this;
        vm.loading.compare = false;
        vm.compareResult = {
          excelOnly: response.excelOnly || [],
          clazzMismatch: response.clazzMismatch || [],
          systemOnly: response.systemOnly || []
        };
        vm.$notify({position: 'bottom-right', type: 'success', message: '比对完成'});
      },
      processCompare: function () {
        var vm = this;
        vm.$confirm('确认处理比对结果吗？Excel单独有的学生将插入系统并分配到对应班级，班级不一致的学生将以Excel班级为准更新系统班级，系统单独有的学生将移动到【休学】班级。', '提示', {type: 'warning', closeOnClickModal: false}).then(() => {
          // 开启遮罩
          vm.loading.compare = true;
          // 请求后台
          vm.$http.post('rest/student/processCompare', {
            grade: vm.compareGrade,
            excelStudents: vm.compareResult.excelOnly,
            mismatchStudents: vm.compareResult.clazzMismatch,
            systemStudentIds: vm.compareResult.systemOnly.map(function (s) { return s.id; })
          }).then(function (response) {
            // 关闭遮罩
            vm.loading.compare = false;
            // 关闭窗口
            vm.visible.compare = false;
            // 刷新
            vm.findByCondition();
            // 提示
            vm.$notify({position: 'bottom-right', type: 'success', message: '处理完成'});
          }, function (response) {
            // 关闭遮罩
            vm.loading.compare = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '处理失败'});
            // 异常处理
            vm.$baize.handle(vm, response);
          })
        }).catch(() => {
          // 提示
          vm.$notify({position: 'bottom-right', type: 'info', message: '取消处理'});
        });
      },
      handlePreview:function (){

      },
      handleRemove:function (){
      },

      // 下载附件
      downloadAttachment: function (record) {
        var vm = this;
        // 开启遮罩
        vm.loading.main = true;
        let xhr = new XMLHttpRequest();
        xhr.open('POST', '/rest/student/download', true);
        xhr.responseType = 'arraybuffer';
        xhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
        xhr.onreadystatechange = function (event) {
          if (this.readyState == 4 && this.status == 200) {
            // 关闭遮罩
            vm.loading.main = false;
            let contentDisposition = xhr.getResponseHeader('Content-Disposition');
            let index = contentDisposition.indexOf("attachment; filename=");
            let fileName = "未知文件"
            if (index >= 0) {
              fileName = contentDisposition.substring(index + 21);
            }
            //生成Blob对象，通过创建的a标签点击下载
            var objectUrl = URL.createObjectURL(new Blob([this.response]));
            var link = document.createElement("a");
            link.download = decodeURIComponent(fileName);
            link.href = objectUrl;
            link.click();
          } else if (this.readyState == 4 && this.status != 200) {
            // 关闭遮罩
            vm.loading.main = false;
            // 提示
            vm.$notify({position: 'bottom-right', type: 'error', message: '下载失败'});
            vm.$baize.handle(vm, {status: this.status, body: this.response});
          }
        };
        xhr.send();
      }

    }
  }
</script>

<style>
  .global-main {
    padding: 5px 0;
    position: relative;
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// src/app/Student.vue